import React, { useEffect, useMemo, useState } from 'react';
import company from "assets/images/icon/company.png";
import companystatus from "assets/images/icon/company-status.png";
import onboard from "assets/images/icon/onboard.png";
import implementation from "assets/images/icon/implementation.png";
import Card from 'components/Card';
import GeneralInformationSection from './GeneralInformationSection';
import WithdrawalBankAccountSection from './WithdrawalBankAccountSection';
import ManageWorkplaces from './ManageWorkplaces';
import ManageDepartments from './ManageDepartments';
import ManagePaySchedules from './ManagePaySchedules';
import ManageEaringCodes from './ManageEaringCodes';

function ManageCompany() {

    const companyDetail = [
        { title: 'Company Id', count: 3, icon: company },
        { title: 'Company Status', count: 0, icon: companystatus },
        { title: 'Onboard', count: 1, icon: onboard },
        { title: 'Implementation', count: 0, icon: implementation }
    ];
    const [activeLink, setActiveLink] = useState("company-information");

    const menuItems = [
        {
            title: "Company Details",
            links: [
                { name: "Company Information", path: "company-information" },
                { name: "Withdrawal Bank Account", path: "withdrawal-bank-account" }
            ]
        },
        {
            title: "Company Management",
            links: [
                { name: "Workplaces", path: "workplaces" },
                { name: "Departments", path: "departments" },
                { name: "Pay Schedules", path: "pay-schedules" },
                { name: "Earning Codes", path: "earning-codes" }
            ]
        },
        {
            title: "Company Onboarding",
            links: [
                { name: "Federal & State Taxes", path: "federal-state-taxes" },
                { name: "Employee Setup", path: "employee-setup" },
                { name: "Filling Authorization", path: "filling-authorization" },
                { name: "Accounting Integration", path: "accounting-integration" }
            ]
        }
    ];
     useEffect(() => {
        const hash = window.location.hash.replace("#", "");
        if (hash) {
            setActiveLink(hash);
        } else {
            setActiveLink("company-information");
        }
    }, []);

    const handleLinkClick = (path) => {
        setActiveLink(path);
        window.location.hash = path;
    };

    const getSectionContent = useMemo(() => {
        switch (activeLink) {
            case "company-information":
                return <GeneralInformationSection />;
            case "withdrawal-bank-account":
                return <WithdrawalBankAccountSection />;
            case "workplaces":
                return <ManageWorkplaces />;
            case "departments":
                return <ManageDepartments />;
            case "pay-schedules":
                return <ManagePaySchedules />;
            case "earning-codes":
                return <ManageEaringCodes />;
            case "federal-state-taxes":
                return <p>Content for Federal & State Taxes</p>;
            case "employee-setup":
                return <p>Content for Employee Setup</p>;
            case "filling-authorization":
                return <p>Content for Filling Authorization</p>;
            case "accounting-integration":
                return <p>Content for Accounting Integration</p>;
            default:
                return <p>Select an option to view details.</p>;
        }
    }, [activeLink]);

    return (
        <div className='content' style={{ padding: "16px 24px 16px 16px" }}>
            <div className="payroll-manage-company-section">
                {/* <div className='breadcrumb-section pb-3 border-bottom'>
                    <h2 className='main-title mb-1'>Payroll</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="home">Home</a></li>
                            <li className="breadcrumb-item"><a href="dashboard">Dashboard</a></li>
                            <li className="breadcrumb-item"><a href="manage-company">Manage Company</a></li>
                        </ol>
                    </nav>
                </div> */}

                <div className="row mt-4">
                    {companyDetail?.map((item) => {
                        return <Card title={item?.title} count={item?.count} icon={item?.icon} />
                    })}
                </div>

                <div className="row pb-4">
                    <div className="col-lg-3">
                        <div className='border-gray cursor-pointer h-100 rounded-3 p-3 mt-4 manage-company-details-section'>
                            {menuItems.map((section, index) => (
                                <div key={index} className={index > 0 ? "mt-4" : ""}>
                                    <h2 className="details-title">{section.title}</h2>
                                    <ul>
                                        {section.links.map((link, idx) => (
                                            <li key={idx} className={activeLink === link.path ? "active" : ""}>
                                                <a href={`${'#'+link.path}`} onClick={() => handleLinkClick(link.path)}>
                                                    {link.name}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-9">
                        <div className='border-gray rounded-3 h-100 p-3 mt-4 manage-company-details-section'>
                            {getSectionContent} 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ManageCompany;
